export const aciCircuits = {
    iconName: 'circuits',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: [
            {
                attr: {
                    d: 'M18.936 16c-.38 0-.634-.132-.761-.527C17.032 13.494 15 10.066 15 8.351 15 5.978 16.778 4 19.064 4 21.349 4 23 5.978 23 8.352c0 1.714-2.032 5.274-3.175 7.12-.254.264-.508.528-.889.528zm0-10.681c-1.523 0-2.793 1.318-2.793 3.033 0 .923 1.016 3.296 2.793 6.066 1.778-2.77 2.794-5.143 2.794-6.066 0-1.715-1.27-3.033-2.794-3.033zM7.662 23a.677.677 0 01-.616-.372c-.123-.372 0-.62.37-.744l13.799-4.837c.37-.125.616 0 .739.372s0 .62-.37.744L7.785 23h-.123zM15.388 15c-.114 0-.227 0-.227-.163l-1.816-1.305c-.34-.163-.454-.652-.227-1.142.114-.326.454-.49.795-.326l1.816 1.305c.227.163.34.652.227 1.142-.227.326-.454.489-.568.489zM6 21c-.405 0-.81-.265-1.081-.53C3.432 18.611 1 15.03 1 13.04 1 10.256 3.297 8 6 8s5 2.255 5 5.04c0 1.99-2.432 5.44-3.919 7.43-.27.265-.676.53-1.081.53zM6 9.327c-2.027 0-3.649 1.724-3.649 3.714 0 1.194 1.352 3.581 3.649 6.5 2.297-2.919 3.649-5.439 3.649-6.5 0-1.99-1.622-3.714-3.649-3.714z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    d: 'M11 10c-.125 0-.25 0-.375-.136-.25-.137-.375-.546-.25-.955.625-1.09 1.125-2.318 1.25-3.545 0-1.637-1.125-3-2.625-3S6.25 3.727 6.25 5.5c0 .136 0 .41.125.545.125.41-.125.682-.375.819-.5.136-.75-.137-.875-.546C5 6.045 5 5.773 5 5.5 5 3.045 6.75 1 9 1s4 2.045 4 4.5c-.375 1.5-.75 2.864-1.5 4.227-.125.137-.375.273-.5.273zM6 14a1 1 0 100-2 1 1 0 000 2z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    d: 'M9 6a1 1 0 100-2 1 1 0 000 2zM19 9a1 1 0 100-2 1 1 0 000 2z',
                    fill: 'currentColor',
                },
            },
        ],
    },
};
